export default __webpack_public_path__ + "static/media/oops-404-error-with-a-broken-robot-animate.3f252aab.svg";